export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-2">
          APP下载
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">随时随地，吃瓜不等待</p>

        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 max-w-4xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs bg-white/20 text-white rounded-full mb-4">
              移动端专属体验
            </span>
            <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-3">
              爆瓜网APP — 瓜田里的速度王者
            </h3>
            <p className="text-white/80 text-sm leading-relaxed mb-6">
              推送速度比网页版快30秒，支持离线阅读和夜间模式。重大爆料第一时间弹窗提醒，不错过任何一口热瓜。已在各大应用商店上架，扫码即下。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="w-full sm:w-auto px-6 py-3 bg-white text-primary-600 font-medium text-sm rounded-full hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill mr-2"></i>
                App Store
              </button>
              <button className="w-full sm:w-auto px-6 py-3 bg-white/15 text-white border border-white/25 font-medium text-sm rounded-full hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill mr-2"></i>
                Android 下载
              </button>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 bg-white rounded-2xl p-2 flex items-center justify-center">
              <div className="w-full h-full bg-background-200 rounded-xl flex flex-col items-center justify-center">
                <i className="ri-qr-code-line text-5xl text-foreground-600 mb-2"></i>
                <span className="text-xs text-foreground-400">扫码下载</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}